import { Controller } from "@hotwired/stimulus"

// Click a board card to open its details in a centered <dialog> modal. The
// dialog lives inside the card so it travels with it during a Sortable drag.
// We guard against the trailing click SortableJS fires after a drag by
// comparing the pointer-down position to the click position — a real drag moves
// the pointer, a click doesn't.
export default class extends Controller {
  static targets = ["dialog"]

  connect() {
    this._down = null
    this._onDown = (e) => { this._down = { x: e.clientX, y: e.clientY } }
    this.element.addEventListener("pointerdown", this._onDown)
  }

  disconnect() {
    this.element.removeEventListener("pointerdown", this._onDown)
  }

  open(event) {
    if (!this.hasDialogTarget || this.dialogTarget.open) return
    // Clicks inside the dialog (incl. the dialog/backdrop itself) bubble up to
    // the card — never re-open from those. (Node.contains is true for self.)
    if (this.dialogTarget.contains(event.target)) return
    // Skip the click that trails a drag.
    if (this._down) {
      const moved = Math.abs(event.clientX - this._down.x) > 6 ||
                    Math.abs(event.clientY - this._down.y) > 6
      if (moved) return
    }
    this.dialogTarget.showModal()
  }

  close() {
    if (this.hasDialogTarget && this.dialogTarget.open) this.dialogTarget.close()
  }

  // Close when the click lands on the backdrop (the dialog element itself,
  // outside the inner panel).
  backdropClose(event) {
    if (event.target === this.dialogTarget) this.dialogTarget.close()
  }
}
